<div class="apresentacoes-globais">
  <div class="row botoes">
    <div kendoTooltip class="col-auto">
      <button class="btn btn-blue mb-2" (click)="abraModalApresentacao()">
        <i class="fe-plus"></i> Adicionar Unidade de Compra
      </button>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="mensagemErro">{{mensagemErro}}</div>

  <div class="card card-body filtros-listagem-insumos mb-3">
    <div class="row align-items-end">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group mb-2">
          <label>Buscar por texto</label>
          <input kendoTextBox class="form-control" placeholder="Descrição, embalagem ou unidade"
                 [(ngModel)]="filtroTexto" (ngModelChange)="filtrePorTexto($event)"/>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group mb-2">
          <label>Embalagem</label>
          <kendo-dropdownlist class="form-control" [data]="embalagensFiltro"
                              textField="nome" valueField="id" [valuePrimitive]="true"
                              [defaultItem]="{id: null, nome: 'Todas as embalagens'}"
                              [(ngModel)]="embalagemFiltroId"
                              (valueChange)="filtrePorEmbalagem($event)">
          </kendo-dropdownlist>
        </div>
      </div>

      <div class="col-auto mb-2" *ngIf="fornecimentoConfigurado">
        <div class="form-group mb-2 filtro-pendencias">
          <input id="somenteUnidadesCompraComPendencias" type="checkbox" class="k-checkbox"
                 kendoCheckBox [(ngModel)]="somenteComPendencias"
                 (ngModelChange)="filtrePorPendencias($event)"/>
          <label class="k-checkbox-label" for="somenteUnidadesCompraComPendencias">
            Listar com pendências
          </label>
        </div>
      </div>

      <div class="col-auto mb-2">
        <button type="button" class="btn btn-light" (click)="limpeFiltros()" [disabled]="!possuiFiltro()">
          <i class="fa fa-times mr-1"></i> Limpar
        </button>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="carregando || !apresentacoesFiltradas.length">
    <div class="card-box">
      <div class="categoria">
        <ng-container *ngIf="carregando">
          <i class="k-icon k-i-loading mr-1"></i> <b>Carregando...</b>
        </ng-container>

        <div class="alert alert-info" *ngIf="!carregando">
          {{apresentacoes.length ? 'Nenhum item encontrado para os filtros informados' : 'Nenhum item cadastrado'}}
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!carregando && apresentacoesFiltradas.length">
    <div class="card" *ngFor="let embalagem of embalagensFiltro"
         [hidden]="!apresentacoesPorEmbalagem[embalagem.id]">
      <div class="categoria">
        <h3 class="ml-2"><b>{{embalagem.nome}}</b></h3>

        <kendo-grid [loading]="carregando" [sortable]="true"
                    [sort]="[{field: 'descricao', dir: 'asc'}]"
                    (edit)="editeApresentacao($event)"
                    (remove)="abraRemocao($event)"
                    [data]="apresentacoesPorEmbalagem[embalagem.id]"
                    [class]="'gridProdutos'">
        <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
                             noRecords="Nenhuma unidade de compra cadastrada"
                             loading="Carregando" pagerItemsPerPage="ítems por página">
        </kendo-grid-messages>

        <kendo-grid-column title="Descrição">
          <ng-template kendoGridCellTemplate let-apresentacao>
            <span><b>{{apresentacao.descricao}}</b></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Conversão" [width]="190">
          <ng-template kendoGridCellTemplate let-apresentacao>
            1 → {{formateFator(apresentacao.fatorConversao)}}
            {{apresentacao.unidadeBase?.sigla}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Vínculos" [width]="150" media="(min-width: 1200px)">
          <ng-template kendoGridCellTemplate let-apresentacao>
            <label class="text-blue cpointer" (click)="abraVinculos(apresentacao)"
                   title="Editar vínculos" kendoTooltip>
              {{apresentacao.totalVinculosAtivos || 0}}
              <i class="fas fa-box-open"></i>
            </label>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Produtos na fábrica" [width]="180" media="(min-width: 1200px)"
                           *ngIf="fornecimentoConfigurado">
          <ng-template kendoGridCellTemplate let-apresentacao>
            <label class="text-blue cpointer mb-0" (click)="abraVinculos(apresentacao)"
                   title="Abrir vínculos e corrigir de/paras" kendoTooltip>
              {{apresentacao.totalDeParas || 0}} vinculado(s)
              <i class="fas fa-link ml-1"></i>
            </label>
            <small class="d-block text-warning" *ngIf="apresentacao.totalPendenciasDePara">
              {{apresentacao.totalPendenciasDePara}} pendente(s)
            </small>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Situação" [width]="110">
          <ng-template kendoGridCellTemplate let-apresentacao>
            <span class="badge" [ngClass]="apresentacao.ativa ? 'badge-success' : 'badge-secondary'">
              {{apresentacao.ativa ? 'Ativa' : 'Inativa'}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="" [width]="160" [class]="{'comandos': true}">
          <ng-template kendoGridCellTemplate let-apresentacao>
            <button kendoGridEditCommand [primary]="true">
              <i class="fa fa-edit" kendoTooltip title="editar"></i>
            </button>
            <button kendoGridRemoveCommand kendoTooltip
                    [disabled]="!podeRemover(apresentacao)"
                    [title]="podeRemover(apresentacao) ? 'Remover unidade de compra' :
                      'Remova primeiro os vínculos com insumos'">
              <i class="fa fa-trash text-danger"></i>
            </button>
          </ng-template>
        </kendo-grid-command-column>
        </kendo-grid>
      </div>
    </div>
  </ng-container>
</div>

<kendo-dialog title="Remover unidade de compra" *ngIf="apresentacaoRemover"
              (close)="canceleRemocao()" [minWidth]="250" [width]="450">
  <p class="m-4 text-center">
    Confirma a remoção da unidade de compra
    "<strong>{{apresentacaoRemover.descricao}}</strong>"?
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="canceleRemocao()" [disabled]="removendo">Cancelar</button>
    <button kendoButton [primary]="true" (click)="confirmeRemocao()" [disabled]="removendo">
      <i class="k-icon k-i-loading mr-1" *ngIf="removendo"></i>Remover
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
